import React, { useState } from 'react';
import { X } from 'lucide-react';
export function Footer() {
  const [modalContent, setModalContent] = useState<'privacy' | 'terms' | null>(null);
  return <footer className="bg-gray-900 text-gray-400 py-12 px-4" data-id="element-238" data-mp="3gh3swj7aaeh9">
      <div className="max-w-lg md:max-w-4xl mx-auto text-center" data-id="element-239" data-mp="32pffmclatjyp">
        <div className="text-2xl font-black text-white mb-6" data-id="element-240" data-mp="36oxw8w6378vq">
          🥦 NUTRIPEQUES
        </div>

        <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm" data-id="element-241" data-mp="3uesani6215i3">
          <button onClick={() => setModalContent('privacy')} className="hover:text-white transition-colors" data-id="element-242" data-mp="38qyt7e9m7ve">
            Política de Privacidad
          </button>
          <button onClick={() => setModalContent('terms')} className="hover:text-white transition-colors" data-id="element-243" data-mp="3le2j4qntu1a6">
            Términos y Condiciones
          </button>
        </div>

        <p className="text-xs" data-id="element-244" data-mp="29y5l8cy0g70t">
          © 2026 NutriPeques. Todos los derechos reservados.
        </p>
        <p className="text-xs mt-4 opacity-50 max-w-2xl mx-auto" data-id="element-245" data-mp="2ez1ja9vokyyb">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>

      {/* Modal */}
      {modalContent && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" data-id="element-246" data-mp="3v5dhwv3o3euj">
          <div className="bg-white rounded-2xl w-full max-w-2xl max-h-[80vh] flex flex-col overflow-hidden shadow-2xl" data-id="element-247" data-mp="82qrjqil5pso">
            <div className="flex justify-between items-center p-4 border-b border-gray-100" data-id="element-248" data-mp="34p8h5l5tqh7">
              <h3 className="text-lg font-bold text-gray-900" data-id="element-249" data-mp="htd4fcyx427o">
                {modalContent === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h3>
              <button onClick={() => setModalContent(null)} className="p-2 text-gray-500 hover:bg-gray-100 rounded-full transition-colors" data-id="element-250" data-mp="qt8ipqnrsdbx">
                <X className="w-5 h-5" data-id="element-251" data-mp="mt7rf5fko7ng" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto text-sm text-gray-600 space-y-4" data-id="element-252" data-mp="tvw7qgxe1ffz">
              {modalContent === 'privacy' ? <>
                  <p data-id="element-253" data-mp="yupnyh427kju">
                    <strong data-id="element-254" data-mp="yrv0egpr1jm7">1. Recopilación de Información</strong>
                    <br data-id="element-255" data-mp="13rps2mhcmd8b" />
                    Recopilamos información cuando te registras en nuestro
                    sitio, realizas una compra o te suscribes a nuestro boletín.
                    La información recopilada incluye tu nombre y correo
                    electrónico.
                  </p>
                  <p data-id="element-256" data-mp="1hiujx2eh6183">
                    <strong data-id="element-257" data-mp="1hmigkaf7v3r1">2. Uso de la Información</strong>
                    <br data-id="element-258" data-mp="1ml3eu4awrdcu" />
                    Cualquier información que recopilemos de ti puede ser
                    utilizada para: personalizar tu experiencia, mejorar nuestro
                    sitio web, mejorar el servicio al cliente y procesar
                    transacciones.
                  </p>
                  <p data-id="element-259" data-mp="3tarq2u3ypdmd">
                    <strong data-id="element-260" data-mp="3tc2vszgywvg4">3. Privacidad del Comercio Electrónico</strong>
                    <br data-id="element-261" data-mp="2agopnmgt8ykn" />
                    Somos los únicos propietarios de la información recopilada
                    en este sitio. Tu información personal no será vendida,
                    intercambiada, transferida o dada a ninguna otra empresa por
                    ningún motivo, sin tu consentimiento, excepto para el
                    propósito expreso de entregar el producto o servicio
                    adquirido.
                  </p>
                  <p data-id="element-262" data-mp="2pc4l9vx1h2j5">
                    <strong data-id="element-263" data-mp="2pdpeni7mafff">4. Divulgación a Terceros</strong>
                    <br data-id="element-264" data-mp="2kd1fuad5cuan" />
                    No vendemos, intercambiamos ni transferimos de ninguna otra
                    manera a terceros tu información de identificación personal.
                    Esto no incluye a terceros de confianza que nos asisten en
                    la operación de nuestro sitio web o en la realización de
                    nuestro negocio, siempre que esas partes acuerden mantener
                    esta información confidencial.
                  </p>
                  <p data-id="element-265" data-mp="2wm7lz2euig3a">
                    <strong data-id="element-266" data-mp="2wmpo2fo6voj4">5. Uso de Cookies</strong>
                    <br data-id="element-267" data-mp="2woalqe5svnl7" />
                    Nuestras cookies mejoran el acceso a nuestro sitio e
                    identifican a los visitantes frecuentes. Además, nuestras
                    cookies mejoran la experiencia del usuario rastreando y
                    apuntando a sus intereses. Sin embargo, este uso de cookies
                    no está vinculado de ninguna manera a ninguna información de
                    identificación personal en nuestro sitio.
                  </p>
                  <p data-id="element-268" data-mp="31nnaj4g8f4qf">
                    <strong data-id="element-269" data-mp="36kdljdd6ja4z">6. Consentimiento</strong>
                    <br data-id="element-270" data-mp="36j2lnomuumj5" />
                    Al utilizar nuestro sitio, aceptas nuestra política de
                    privacidad.
                  </p>
                </> : <>
                  <p data-id="element-271" data-mp="1v6iaafpeblj1">
                    <strong data-id="element-272" data-mp="1v6rxxwmyxglk">1. Aceptación de los Términos</strong>
                    <br data-id="element-273" data-mp="1nl66zrcm99jz" />
                    Al acceder y utilizar este producto digital (NutriPeques),
                    aceptas estar sujeto a estos Términos y Condiciones. Si no
                    estás de acuerdo con alguna parte de los términos, no podrás
                    acceder al producto.
                  </p>
                  <p data-id="element-274" data-mp="1ro2kx4r7ohhl">
                    <strong data-id="element-275" data-mp="1rlq5ozcu8l88">2. Producto Digital</strong>
                    <br data-id="element-276" data-mp="13z039wwkuon3" />
                    NutriPeques es un producto digital (eBook/Guía). El acceso
                    se proporciona inmediatamente después de la compra exitosa.
                    No se enviará ningún producto físico.
                  </p>
                  <p data-id="element-277" data-mp="18xbgmhm2zha2">
                    <strong data-id="element-278" data-mp="18wt8amm59cls">3. Política de Reembolso</strong>
                    <br data-id="element-279" data-mp="18v8itbeosjus" />
                    Ofrecemos una garantía de devolución de dinero de 30 días.
                    Si no estás satisfecho con el producto, puedes solicitar un
                    reembolso completo dentro de los 30 días posteriores a la
                    compra. Pasados los 30 días, no se emitirán reembolsos bajo
                    ninguna circunstancia.
                  </p>
                  <p data-id="element-280" data-mp="2q0ghyxldzs1v">
                    <strong data-id="element-281" data-mp="2q06rza0cdkw6">4. Propiedad Intelectual</strong>
                    <br data-id="element-282" data-mp="2q2szj9n8g0ee" />
                    Todo el contenido incluido en NutriPeques (textos, gráficos,
                    logotipos, imágenes, compilaciones de datos y software) es
                    propiedad de NutriPeques y está protegido por las leyes de
                    derechos de autor. No puedes reproducir, distribuir,
                    modificar, crear trabajos derivados, exhibir públicamente,
                    ejecutar públicamente, republicar, descargar, almacenar o
                    transmitir ninguno de los materiales de nuestro producto sin
                    el consentimiento previo por escrito.
                  </p>
                  <p data-id="element-283" data-mp="3mpo3i5m0a15s">
                    <strong data-id="element-284" data-mp="3mowbf4rmalk9">5. Limitación de Responsabilidad</strong>
                    <br data-id="element-285" data-mp="1b2avn8gbp39c" />
                    La información proporcionada en NutriPeques es solo para
                    fines educativos e informativos. No sustituye el consejo
                    médico profesional, diagnóstico o tratamiento. Siempre busca
                    el consejo de tu médico, pediatra u otro proveedor de salud
                    calificado con cualquier pregunta que puedas tener sobre una
                    condición médica o la alimentación de tu hijo.
                  </p>
                  <p data-id="element-286" data-mp="nd05sm0igt9z">
                    <strong data-id="element-287" data-mp="ncgo96erw6wh">6. Modificaciones</strong>
                    <br data-id="element-288" data-mp="jbekqddtp8op" />
                    Nos reservamos el derecho de modificar o reemplazar estos
                    Términos en cualquier momento. Es tu responsabilidad revisar
                    estos Términos periódicamente para ver si hay cambios.
                  </p>
                </>}
            </div>
            <div className="p-4 border-t border-gray-100 bg-gray-50 text-right" data-id="element-289" data-mp="28s5szfa8zdzd">
              <button onClick={() => setModalContent(null)} className="px-6 py-2 bg-gray-900 text-white rounded-xl font-bold hover:bg-gray-800 transition-colors" data-id="element-290" data-mp="1hlid2u12i72r">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </footer>;
}